module.exports = __webpack_public_path__ + "static/media/aiDesignerAxisTemplate3.b4c2703d.jpg";